import React, { useEffect, useState } from "react";
import { getApprovedTestimonialsApi } from "../../api/testimonialService";
import StatusBadge from "../Shared/StatusBadge";
import FullPageLoader from "../../common/FullPageLoader";
import EmptyState from "../../common/EmptyState";

const ApprovedTestimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTestimonials = async () => {
    try {
      const response = await getApprovedTestimonialsApi();
      setTestimonials(
        response.data.testimonials || response.testimonials || [],
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTestimonials();
  }, []);

  if (loading) {
    return <FullPageLoader text="Loading approved testimonials..." />;
  }

  return (
    <div className="container-fluid p-4 np-testimonials-page">
      
      <div className="card p-3">
        {testimonials.length === 0 ? (
          <EmptyState />
        ) : (
          <>
      <table className="table table-bordered table-hover align-middle">
        <thead className="table-light">
          <tr>
            <th className="fw-bold text-black">#</th>
            <th className="fw-bold text-black"> Product Name</th>
            <th className="fw-bold text-black">city And State</th>
            <th className="fw-bold text-black">Rating</th>
            <th className="fw-bold text-black">Status</th>
          </tr>
        </thead>

        <tbody>
          {testimonials.map((item, index) => (
              <tr key={item._id}>
                <td>{index + 1}</td>
                <td>{item.name}</td>

                <td>
                  {item.city},{item.state}
                </td>
                <td>
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      style={{
                        color: star <= item.rating ? "#ffc107" : "#d6d6d6",
                        fontSize: "18px",
                      }}
                    >
                      ★
                    </span>
                  ))}
                </td>
                <td>
                  <StatusBadge status={item.status} />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
        </>
        )}
      </div>
    </div>
  );
};

export default ApprovedTestimonials;
